import dayjs from "dayjs";
import { useContext, useMemo } from "react";
import BorseContext from "../../context/borse";
import { getAnswerValue } from "../../utils/partial";
import Tooltip from "../tooltip";
import BorseStep1 from "./borse-step-1";
import BorseStep2 from "./borse-step-2";
import BorseStep3 from "./borse-step-3";
import BorseStep4 from "./borse-step-4";
import DocumentIntegration from "./document-integration";
import RequestOutcome from "./request-outcome";

const BorseSurvey = ({ discardModal, setDiscardModal }) => {
  const { path, survey, labels, currentSectionIndex, currentRequest, appLang } =
    useContext(BorseContext);

  const section = useMemo(
    () => survey?.definition?.sections?.find((section) => section.id === path?.slice(-1)?.[0]),
    [path, survey]
  );

  return (
    <div className="wrapper wrapper--app wrapper-small">
      {currentRequest?.status === "INTEGRATION_NEEDED" && <DocumentIntegration />}
      {["ASSIGNED", "NOT_ASSIGNED"].includes(currentRequest?.status) && <RequestOutcome />}
      {currentRequest?.status === "DRAFT" || currentRequest === "new" ? (
        <>
          <span className="app-content__step">
            {labels?.WELFARE_STEP || "Step"} {path.length}
          </span>
          <div className="app-content__title-wrapper">
            <h2 className="app-content__title">
              {currentSectionIndex === 3
                ? labels?.WELFARE_BORSE_STEP4_TITLE || "Riepilogo della richiesta"
                : section?.label}
            </h2>
            {section?.description && (
              <Tooltip
                id="BorseTooltip"
                className="borse-content__tooltip"
                tooltipContent={<div dangerouslySetInnerHTML={{ __html: section.description }} />}
              />
            )}
          </div>
          {currentSectionIndex === 3 && (
            <div
              className="app-content__text"
              dangerouslySetInnerHTML={{
                __html:
                  labels?.WELFARE_BORSE_STEP4_DESCR_DRAFT ||
                  "<strong>La tua richiesta è in bozza, controlla la correttezza dei tuoi dati prima di inviarla definitivamente.</strong>",
              }}
            />
          )}
        </>
      ) : ["ASSIGNED", "NOT_ASSIGNED"].includes(currentRequest?.status) ? (
        <div className="app-content__text">
          <strong>
            {(
              labels?.WELFARE_BORSE_REQUEST_SENT_REVIEW || "Riepilogo richiesta per: [SCHOOL]"
            ).replace(
              "[SCHOOL]",
              getAnswerValue(
                survey,
                currentRequest?.surveySubmission?.answers,
                1,
                5
              )?.label?.toLowerCase() || ""
            )}
          </strong>
        </div>
      ) : (
        currentRequest?.status !== "EXPIRED_DRAFT" &&
        currentRequest?.sentDate && (
          <div className="app-content__text">
            <strong>
              {(labels?.WELFARE_BORSE_REQUEST_SENT_DATE || "Request sent on [DATE]").replace(
                "[DATE]",
                dayjs(Number(currentRequest?.sentDate)).locale(appLang?.value).format("L")
              )}
            </strong>
          </div>
        )
      )}
      {
        {
          0: <BorseStep1 discardModal={discardModal} setDiscardModal={setDiscardModal} />,
          1: <BorseStep2 discardModal={discardModal} setDiscardModal={setDiscardModal} />,
          2: <BorseStep3 discardModal={discardModal} setDiscardModal={setDiscardModal} />,
          3: <BorseStep4 discardModal={discardModal} setDiscardModal={setDiscardModal} />,
        }[currentSectionIndex]
      }
    </div>
  );
};

export default BorseSurvey;
